<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal [title]="title() ?? ''" (closeModal)="onClose()">
      <div modal-content>
        <div class="flex justify-center">
          <mat-icon class="text-[32px]! w-8! h-8! text-ld-success!">check_circle</mat-icon>
        </div>

        <p id="message-success-message" class="font-dm text-base text-ld-neutral-500 text-center">
          {{ message() }}
        </p>
      </div>

      <div modal-footer>
        @if (showViewSent()) {
          <button id="message-success-view-sent-btn" type="button" class="btn-primary-ld-purple" (click)="onViewSent()">
            {{ t('modalsMessageSuccessViewSentButton') }}
          </button>
        }
        <button
          id="message-success-ok-btn"
          type="button"
          [class]="showViewSent() ? 'btn-outline-ld-purple' : 'btn-primary-ld-purple'"
          (click)="onClose()"
        >
          {{ showViewSent() ? t('commonAriaClose') : t('commonButtonsOk1') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
